export default "__VITE_ASSET__mchDfspH__"